/**
 * ステータス獲得（status_gain）の表示用ヘルパー。
 *
 * ラベル定義が実績カード・詳細モーダル・AI判定リザルトに重複しており、
 * 片方だけ更新されて運が「luck」と生表示される不具合が出たため共通化した。
 */

/** 6ステータスのキーと日本語ラベル。表示順もこの定義順に揃える。 */
export const STATUS_LABELS: Record<string, string> = {
  intelligence: '知力',
  dexterity:    '器用さ',
  physical:     '体力',
  financial:    '財力',
  mental:       '精神力',
  charm:        '魅力',
}

/** 運は増減で色を変えるため、6ステータスとは分けて扱う。 */
export const LUCK_LABEL = '運'

export type StatusGainEntry = { key: string; label: string; val: number }

/**
 * 表示対象の6ステータスを定義順で返す（獲得が0のものは除く）。
 * ラベル定義側をループするので、未知のキーが生のまま表示されることはない。
 */
export function statusGainEntries(statusGain: Record<string, number>): StatusGainEntry[] {
  return Object.entries(STATUS_LABELS)
    .map(([key, label]) => ({ key, label, val: statusGain[key] ?? 0 }))
    .filter(({ val }) => val > 0)
}

/**
 * 運の増減を取り出す（0 でもそのまま返す）。
 * 0 のときに非表示にするかは呼び出し側の判断に委ねる。
 */
export function luckGain(statusGain: Record<string, number>): number {
  return statusGain['luck'] ?? 0
}
